<template>
    <div class="wrapper">
        <h1 class="crumb">安装单列表</h1>
        <div class="bar">
            <div class="btnGroup">
                <span style="">安装日期　</span>
                <el-date-picker
                    v-model="installDate"
                    type="daterange"
                    range-separator="至"
                    @change="getInstallList"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                <span style="margin-left: 50px">订单添加时间</span>
                <el-date-picker
                    v-model="addDate"
                    type="daterange"
                    range-separator="至"
                    @change="getInstallList"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                <!--<el-button class="btn" @click="searchOrder" style="margin-left: 20px">搜索</el-button>-->
                <el-select v-model="ssgn" placeholder="请选择" style="width: 150px;margin-left: 50px" @change="selectCompanys">
                    <el-option
                        v-for="item in ssgnSelect"
                        :key="item.referer"
                        :label="item.name"
                        :value="item.referer"
                        >
                    </el-option>
                </el-select>
                <span><el-input v-model="searchKey" style="width: 200px" placeholder="请输入" v-show="isCompany === false"></el-input></span>
                <span v-show="isCompany === true">
                    <el-select v-model="searchKey" placeholder="公司名称" >
                        <el-option v-for="item in selectCompany" :label="item.company_name" :value="item.company_name" :key="item.name"></el-option>
                    </el-select>
                </span>
                <el-button class="btn" @click="getInstallList" style="">搜索</el-button>
                <el-button class="btn" @click="Report" style="margin-top: 20px;margin-left: -5px">安装单导出</el-button>
                <span style="margin-left: 50px">订单来源　</span>
                <el-select v-model="ddly" placeholder="请选择" style="width: 100px" @change="getInstallList">
                    <el-option
                        v-for="item in ddlySelect"
                        :key="item.referer"
                        :label="item.name"
                        :value="item.referer">
                    </el-option>
                </el-select>
                <span style="margin-left: 50px;">安装状态　</span>
                <el-select v-model="azzt" placeholder="请选择" style="width: 150px;"  @change="getInstallList">
                    <el-option
                        v-for="item in azztSelect"
                        :key="item.referer"
                        :label="item.name"
                        :value="item.referer"
                    >
                    </el-option>
                </el-select>
                <span style="margin-left: 50px">配送方式　</span>
                <el-select v-model="psfs" placeholder="请选择" style="width: 100px" @change="getInstallList">
                    <el-option
                        v-for="item in psfsSelect"
                        :key="item.referer"
                        :label="item.name"
                        :value="item.referer">
                    </el-option>
                </el-select>
            </div>
        </div>
        <el-table
            :data="tableData"
            v-loading="loading"
            style="width: 100%"
            class="tbs"
        >
            <el-table-column label="操作" align="center" width="180">
                <template slot-scope="props">
                    <a @click="Look(props.row)" v-show="props.row.status_name==='已安装'">查看</a><a v-show="props.row.status_name==='已安装'"> | </a>
                    <a @click="orderJiesuan(props.row)">结算</a><a> | </a>
                    <a @click="OrderBiangeng(props.row)" v-if="props.row.status_name ==='未安装'&&props.row.delivery_method_name==='送装'">变更</a><a v-if="props.row.status_name ==='未安装'&&props.row.delivery_method_name==='送装'"> | </a>
                    <a @click="orderDelete(props.row)">作废</a>| </a>
                    <a target="_blank" :href="'/yixing2.0/#/OrderList/'+props.row.sn">订单详情</a><!--@click="OrderDetail(props.row)"-->
                </template>
            </el-table-column>
            <el-table-column label="销售公司" prop="store_name" show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column label="下单员" prop="post_name"  align="center"></el-table-column>
            <el-table-column label="订单号" width="100" align="center">
                <template slot-scope="props">
                    <div  style="font-size: 10px;" :style="props.row.referer ==='管理员添加'?{color:'red'}:''">{{props.row.referer !=='管理员添加'?props.row.order_sn:'只安装'}}</div>
                </template>
            </el-table-column>
            <el-table-column label="合同订单号" prop="contract_number" width="100" align="center"></el-table-column>
            <el-table-column label="型号" width="120" align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.order_goods" style="font-size: 10px">{{item.goods_attr_select.length ===0?item.goods_attr:item.goods_attr_select[0]}}</div>
                </template>
            </el-table-column>
            <el-table-column label="数量" width="50" align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.order_goods">{{item.goods_number}}</div>
                </template>
            </el-table-column>
            <el-table-column label="送货地址" prop="address_all"  align="center" width="130"></el-table-column>
            <el-table-column label="收货人" prop="consignee" width="70" align="center"></el-table-column>
            <el-table-column label="联系方式" prop="mobile" width="110" align="center"></el-table-column>
            <!--<el-table-column label="备用电话" prop="tel" width="110" align="center"></el-table-column>-->
            <el-table-column label="送货方式" prop="delivery_method_name"  align="center" width="60"></el-table-column>
            <el-table-column label="安装公司" prop="company_name" align="center"></el-table-column>
            <!--<el-table-column align="center" label="安装费用" width="120" >-->
                <!--<template slot-scope="props">-->
                    <!--<div @click="Details(props.row,+props.row.fee_gaokong+ +props.row.fee_nandu+ +props.row.fee_yuancheng+ +props.row.fee_chaizhuang+ +props.row.fee_gangguan+ +props.row.fee_zhijia)" style="cursor: pointer;color: orangered;">￥{{+props.row.fee_gaokong+ +props.row.fee_nandu+ +props.row.fee_yuancheng+ +props.row.fee_chaizhuang+ +props.row.fee_gangguan+ +props.row.fee_zhijia}}</div>-->
                <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column label="备注" prop="remark" align="center" width="100"></el-table-column>
            <el-table-column label="公司备注" prop="company_remark" align="center"></el-table-column>
            <el-table-column label="预约时间" prop="yuyue_time"  sortable align="center"></el-table-column>
            <el-table-column label="订单变更"   sortable align="center">
                <template slot-scope="props">
                    <span style="color: red">{{props.row.change_time =='0'||props.row.change_time ==''?'':props.row.change_time|formatter}}</span>
                </template>
            </el-table-column>
            <el-table-column label="安装单状态"  align="center">
                <template slot-scope="props">
                    <div style="color: white;height:50px;line-height:50px;margin: 0;padding: 0; font-size: 12px;" :style="props.row.status_name=='未安装'?{color:'#1b345d'}:{color:'#5bc377'}">
                        {{props.row.status_name}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="订单添加时间" prop="addtime" align="center" sortable></el-table-column>
        </el-table>
        <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="10"
            layout=" total,prev, pager, next"
            :total="total">
        </el-pagination>
        <el-dialog :visible.sync="dialogXiapai"
                   title="下派安装公司">
            <el-form ref="form" :rules="rules" :model="formData" style="padding: 30px" >
            <el-form-item label="公司名称：" prop="company_name" label-width="100" style="text-align: left">
                <el-select v-model="formData.company_id" placeholder="公司名称" @change="selectname(formData.company_id)">
                    <el-option v-for="item in selectList" :label="item.company_name" :value="item.company_id" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogXiapai = false">取 消</el-button>
                <el-button type="primary" @click="queren">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="费用详情" :visible.sync="FeiyongDetail" width="400px">
            <div v-show="form.fee_other=='0'||typeof form.fee_other!=='object'">{{tests}}</div>
            <el-form :model="form" style="text-align: left;margin-top: 20px;" class="c-table">
                <el-form-item :label="item.name?item.name+':':''" :label-width="formLabelWidth" v-for="item in form.fee_other" :key="item.name" v-show="typeof form.fee_other==='object'">
                    <div>{{item.price}}</div>
                </el-form-item>
                <el-form-item label="支架费:" :label-width="formLabelWidth" v-show="form.fee_zhijia!=='0.00'">
                    <div>{{form.fee_zhijia}}</div>
                </el-form-item>
                <el-form-item label="高空费:" :label-width="formLabelWidth" v-show="form.fee_gaokong!=='0.00'">
                    <div>{{form.fee_gaokong}}</div>
                </el-form-item>
                <el-form-item label="铜管费:" :label-width="formLabelWidth" v-show="form.fee_gangguan!=='0.00'">
                    <div>{{form.fee_gangguan}}</div>
                </el-form-item>
                <el-form-item label="难度费:" :label-width="formLabelWidth" v-show="form.fee_nandu!=='0.00'">
                    <div>{{form.fee_nandu}}</div>
                </el-form-item>
                <el-form-item label="远程费:" :label-width="formLabelWidth" v-show="form.fee_yuancheng!=='0.00'">
                    <div>{{form.fee_yuancheng}}</div>
                </el-form-item>
                <el-form-item label="拆装机费:" :label-width="formLabelWidth" v-show="form.fee_chaizhuang!=='0.00'">
                    <div>{{form.fee_chaizhuang}}</div>
                </el-form-item>
                <el-form-item label="其他费用:" :label-width="formLabelWidth" v-show="form.fee_other!='0'&&typeof form.fee_other!=='object'">
                    <div>{{form.fee_other}}</div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                <el-button @click="FeiyongDetail = false">关 闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="安装单详情" :visible.sync="InstallDetail">
            <el-form :model="form">
                <el-form-item label="安装信息:" :label-width="formLabelWidth">
                    <div v-if="form.finish_time === ''">{{form.status_name}}</div>
                    <div v-else>{{form.status_name }} ({{form.yuyue_time}})</div>
                </el-form-item>
                <!--<el-form-item label="安装变更记录:" :label-width="formLabelWidth">-->
                    <!--<div v-if="form.finish_time === ''">暂无安装变更记录</div>-->
                    <!--<div v-else>{{form.comment}}</div>-->
                <!--</el-form-item>-->
                <el-form-item label="客户评价:" :label-width="formLabelWidth">
                    <div>{{form.comment}}</div>
                </el-form-item>
                <el-form-item label="评分:" :label-width="formLabelWidth">
                    <div><span>安装及时:</span><el-rate disabled v-model="form.service_send" style="display: inline-block"></el-rate></div>
                    <div><span>安装态度:</span><el-rate disabled v-model="form.service_state" style="display: inline-block"></el-rate></div>
                    <div><span>安装规范:</span><el-rate disabled v-model="form.service_clear" style="display: inline-block"></el-rate></div>
                </el-form-item>
                <el-form-item :label="item.name?item.name+':':''" :label-width="formLabelWidth" v-for="item in form.fee_other" :key="item.name" v-show="typeof form.fee_other==='object'">
                    <div>{{item.price}}</div>
                </el-form-item>
                <el-form-item label="支架费:" :label-width="formLabelWidth" v-show="form.fee_zhijia!=='0.00'">
                    <div>{{form.fee_zhijia}}</div>
                </el-form-item>
                <el-form-item label="高空费:" :label-width="formLabelWidth" v-show="form.fee_gaokong!=='0.00'">
                    <div>{{form.fee_gaokong}}</div>
                </el-form-item>
                <el-form-item label="铜管费:" :label-width="formLabelWidth" v-show="form.fee_gangguan!=='0.00'">
                    <div>{{form.fee_gangguan}}</div>
                </el-form-item>
                <el-form-item label="难度费:" :label-width="formLabelWidth" v-show="form.fee_nandu!=='0.00'">
                    <div>{{form.fee_nandu}}</div>
                </el-form-item>
                <el-form-item label="远程费:" :label-width="formLabelWidth" v-show="form.fee_yuancheng!=='0.00'">
                    <div>{{form.fee_yuancheng}}</div>
                </el-form-item>
                <el-form-item label="拆装机费:" :label-width="formLabelWidth" v-show="form.fee_chaizhuang!=='0.00'">
                    <div>{{form.fee_chaizhuang}}</div>
                </el-form-item>
                <el-form-item label="其他费用:" :label-width="formLabelWidth" v-show="form.fee_other!=='0'&&typeof form.fee_other!=='object'">
                    <div>{{form.fee_other}}</div>
                </el-form-item>
                <el-form-item label="附件查询:" :label-width="formLabelWidth">
                    <div v-if="form.image1 === '/data/paylogimg/'&&form.image2 === '/data/paylogimg/'&&form.image3 === '/data/paylogimg/'" >暂无附件</div>
                    <div v-else>
                        <a target="_blank" :href="$reqUrl + form.image1" v-show="form.image1 !== '/data/paylogimg/'"><img :src="$reqUrl + form.image1" style="width: 50px;height: 50px"></a>
                        <a target="_blank" :href="$reqUrl + form.image2" v-show="form.image2 !== '/data/paylogimg/'"><img :src="$reqUrl + form.image2" style="width: 50px;height: 50px"></a>
                        <a target="_blank" :href="$reqUrl + form.image3" v-show="form.image3 !== '/data/paylogimg/'"><img :src="$reqUrl + form.image3" style="width: 50px;height: 50px"></a>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                <el-button @click="InstallDetail = false">关 闭</el-button>
            </div>
        </el-dialog>
        <!--添加安装单-->
        <el-dialog :visible.sync="showAddInstall"
                   title="添加安装单">
            <el-form ref="azform" :rules="rules" :model="addForm" style="padding: 30px" >

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showAddInstall = false">取 消</el-button>
                <el-button type="primary" @click="qrtj">确 定</el-button>
            </span>
        </el-dialog>
        <!--安装单变更-->
        <el-dialog :visible.sync="showBiangeng"
                   title="安装单变更">
            <el-form :model="form">
                <el-form-item label="客户姓名:" :label-width="formLabelWidth">
                    <el-input v-model="bgform.consignee" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系电话:" :label-width="formLabelWidth">
                    <el-input v-model="bgform.mobile" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="安装公司:" :label-width="formLabelWidth">
                    <el-select v-model="biangengData.company_id" placeholder="公司名称" @change="selectname(biangengData.company_id)">
                        <el-option v-for="item in selectCompany" :label="item.company_name" :value="item.company_id" :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预约时间" :label-width="formLabelWidth">
                    <el-date-picker
                        v-model="biangengData.azTime"
                        @change="consl"
                        type="date"
                        placeholder="选择时间"
                        :picker-options="pickerOptions0"></el-date-picker>
                </el-form-item>
                <el-form-item label="送货地址:" :label-width="formLabelWidth">
                    <div v-show="changeAddress == false"><span style="float: left">{{bgform.address_all}}</span><el-button type="primary" @click="isChangeAddr" >修改地址</el-button></div>
                    <div v-if="changeAddress == true">
                        <!--<el-select v-model="biangengData.province" placeholder="省份" style="width: 90px;">-->
                            <!--<el-option-->
                                <!--v-for="{region_id, region_name} in provinceList"-->
                                <!--:key="region_id"-->
                                <!--:value="region_id"-->
                                <!--:label="region_name"-->
                            <!--&gt;-->
                            <!--</el-option>-->
                        <!--</el-select>-->
                        <!--<el-select v-model="biangengData.city" placeholder="城市" style="width: 90px;">-->
                            <!--<el-option-->
                                <!--v-for="{region_id, region_name} in cityList"-->
                                <!--:key="region_id"-->
                                <!--:value="region_id"-->
                                <!--:label="region_name"-->
                            <!--&gt;</el-option>-->
                        <!--</el-select>-->
                        <!--<el-select v-model="biangengData.district" placeholder="区" style="width: 90px;">-->
                            <!--<el-option-->
                                <!--v-for="{region_id, region_name} in districtList"-->
                                <!--:key="region_id"-->
                                <!--:value="region_id"-->
                                <!--:label="region_name"-->
                            <!--&gt;</el-option>-->
                        <!--</el-select>-->
                        <el-input :rows="3" type="textarea" placeholder="详细地址信息" v-model="biangengData.address" style="margin-top: 15px"></el-input>
                        <!--<a @click="SureChangeAddr">确认修改</a><a>　|　</a>-->
                        <a @click="FalseChangeAddr">取消修改</a>
                    </div>
                </el-form-item>
                <el-form-item label="备注:" :label-width="formLabelWidth">
                    <el-input v-model="biangengData.remark" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showBiangeng = false">取 消</el-button>
                <el-button type="primary" @click="qrbiangeng">确 定</el-button>
            </span>
        </el-dialog>
    </div>

</template>
<script>
    import qs from 'qs'
    import { mapState } from 'vuex';
    import {getInstallList, getInstallCompany, getAddressSelect, ChargeCompany} from '../stores/api'
    export default {
        data() {
            return {
                dialogXiapai: false,
                InstallDetail: false,
                showAddInstall: false,
                showBiangeng: false,
                changeAddress: false, //是否修改地址
                page: 1,
                total: '',
                loading: false,
                page_count: 1,
                tableData: [],
                selectList: [],
                selectCompany: [],
                ddlySelect: [{name: '全部', referer: ''}, {name: 'k3导入', referer: 'k3导入'}, {name: '新增', referer: '管理员添加'}, {name: 'PC商城', referer: 'PC'}, {name: '供应链', referer: '供应链'}, {name: '门店', referer: '门店'}, {name: '扫码', referer: '扫码'}],
                ddly: '',
                azztSelect: [{name: '全部', referer: ''}, {name: '未安装', referer: '7'}, {name: '已安装', referer: '3'}],
                azzt: '未安装',
                ssgnSelect: [{name: '合同订单号', referer: 'contract_number'}, {name: '收货人电话', referer: 'mobile'}, {name: '安装公司', referer: 'company_name'}, {name: '型号', referer: 'goods_attr'}, {name: '地址', referer: 'address'}],
                ssgn: 'contract_number',
                psfsSelect: [{name: '全部', referer: ''}, {name: '送货', referer: 0}, {name: '物流', referer: 1}, {name: '自提', referer: 2}, {name: '送装', referer: 3},{name: '只安装', referer: 10}, {name: '占用库存', referer: 11}, {name: '快递', referer: 4}, {name: '直发', referer: 5}, {name: '铺管', referer: 9}, {name: '其他', referer: 6}],
                psfs: 3,
                searchKey: '', //关键字搜索
                installDate: '', //安装日期搜索
                addDate: '', //订单添加时间
                formData: {
                    company_id: '',
                    company_name: '',
                    install_id: '',
                    // session_id: localStorage.getItem('session_id'),
                },
                bgform: '',
                biangengData: {
                        goodsSelect: 3, //配送方式
                        wuliu_pay: '',
                        azTime: new Date(),
                        yytime: '', //安装时间
                        company_id: '',
                        company_name: '',
                        province: '', //省
                        city: '', //市
                        district: '', //区
                        address: '', //详细地址
                        remark: '',
                        install_id: '',
                        order_id: '',
                        order_sn: '',
                },
                addForm: {
                    goods: [],
                    consignee: '',
                    mobile: '',
                    delivery_method: '3',

                },
                formLabelWidth: '120px',
                form: {},
                isCompany: false, //搜索条件是否是安装公司
                FeiyongDetail: false,
                tests: '',
            }
        },
        created() {
                this.getInstallList()
            this.getInstallCompanyList()
        },
        filters: {
            formatter(time) {
                if (time !== '' && time !== '0') {
                    return new Date(Number(time * 1000)).toLocaleDateString().replace(/\//g, " - " )
                }

            },
        },
        methods: {
            getInstallList() {
                this.loading = true
                let session_id = localStorage.getItem('shouhou_session_id')
                let temp = {}
                if (this.installDate) {
                    // console.log(this.installDate)
                    temp.addtime1 = Date.parse(this.installDate[0].toLocaleDateString()).toString().slice(0, 10)
                    temp.addtime2 = +Date.parse(this.installDate[1].toLocaleDateString()).toString().slice(0, 10) + 60 * 60 * 24
                }
                if (this.addDate) {
                    temp.add_time1 = Date.parse(this.addDate[0].toLocaleDateString()).toString().slice(0, 10)
                    temp.add_time2 = +Date.parse(this.addDate[1].toLocaleDateString()).toString().slice(0, 10) + 60 * 60 * 24
                }
                temp.page = this.page
                if (this.azzt !== '') {
                    temp.status = this.azzt
                }
                if (this.ddly !== '') {
                    temp.referer = this.ddly
                }
                temp.delivery_method = this.psfs
                if (this.searchKey !== '') {
                    if (this.ssgn === 'contract_number') {
                        temp.contract_number = this.searchKey
                    } else if (this.ssgn === 'mobile') {
                        temp.mobile = this.searchKey
                    } else if (this.ssgn === 'company_name') {
                        temp.company_name = this.searchKey
                    } else if (this.ssgn === 'goods_attr') {
                        temp.goods_attr = this.searchKey
                    } else if (this.ssgn === 'address') {
                        temp.address = this.searchKey
                    }
                }
                getInstallList(temp).then(res => {
                    this.loading = false
                    // console.log(res.data.install_list)
                    this.tableData = res.data.install_list
                    this.total = res.data.count
                    if (res.data.install_list){
                        this.tableData.forEach((item, i) => {
                            this.tableData[i]['addr'] = item.province + item.city + item.district + item.address
                        })
                    }

                })
            },
            Report() {
                let temp = {}
                if (this.installDate) {
                    // console.log(this.installDate)
                    temp.addtime1 = Date.parse(this.installDate[0].toLocaleDateString()).toString().slice(0, 10)
                    temp.addtime2 = +Date.parse(this.installDate[1].toLocaleDateString()).toString().slice(0, 10) + 60 * 60 * 24
                }
                if (this.addDate) {
                    temp.add_time1 = Date.parse(this.addDate[0].toLocaleDateString()).toString().slice(0, 10)
                    temp.add_time2 = +Date.parse(this.addDate[1].toLocaleDateString()).toString().slice(0, 10) + 60 * 60 * 24
                }
                if (this.azzt !== '') {
                    temp.status = this.azzt
                }
                if (this.ddly !== '') {
                    temp.referer = this.ddly
                }
                temp.delivery_method = this.psfs
                if (this.searchKey !== '') {
                    if (this.ssgn === 'contract_number') {
                        temp.contract_number = this.searchKey
                    } else if (this.ssgn === 'mobile') {
                        temp.mobile = this.searchKey
                    } else if (this.ssgn === 'company_name') {
                        temp.company_name = this.searchKey
                    } else if (this.ssgn === 'goods_attr') {
                        temp.goods_attr = this.searchKey
                    } else if (this.ssgn === 'address') {
                        temp.address = this.searchKey
                    }
                }
                var str = ''
                for (var key in temp) {
                    str += '&' + key + '=' + temp[key]
                }
                window.open(this.$reqUrl + `service.php?act=install_list_excel&session_id=${localStorage.getItem('shouhou_session_id')}${str}`)
            },
            searchOrder() {
               this.getInstallList()
            },
            //是否选择安装公司
            selectCompanys () {
                if (this.ssgn === 'company_name') {
                    this.isCompany = true
                    this.searchKey = this.selectCompany[0].company_name
                } else {
                    this.isCompany = false
                    this.searchKey = ''
                }
            },
            Details (row, price) {
                this.form = row
                this.tests = ''
                if (price === 0) {
                    this.tests = '无安装费用'
                }
                // console.log(row);
                this.FeiyongDetail = true
            },
            getInstallCompanyList () {
                getInstallCompany(this.page).then(res => {
                    this.selectCompany = []
                    this.selectCompany = res.data.company_list
                    this.page_count = res.data.page_count
                    if (this.page_count > 1) {
                        this.page = 2;
                        for (var i = 0; i < this.page_count - 1; i++) {
                            this.page += i;
                            getInstallCompany(this.page).then(res => {
                                res.data.company_list.forEach(item => {
                                    this.selectCompany.push(item)
                                })
                            })
                        }
                        // console.log(this.selectCompany)
                    }
                })
            },
            //添加安装单
            addInstall () {
              this.showAddInstall = true
            },
            handleCurrentChange(val) {
                this.page = val
                this.getInstallList()
            },
             //订单详情
            OrderDetail(order) {
                localStorage.setItem('temp', JSON.stringify(this.temp))
                localStorage.setItem('isDetail', this.isDetail)
                this.$router.push('/OrderList/' + order.sn)
            },
            orderDelete (row) {
                this.$alert('确定撤销该安装单?', '安装单撤销', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    // callback: action => {
                    // }
                }).then(() => {
                            this.$http.get(this.$reqUrl + `service.php?act=install_del&session_id=${localStorage.getItem('shouhou_session_id')}&install_id=${row.install_id}`).then(res => {
                                if (res.data.error === 0) {
                                    this.$message.success(res.data.msg)
                                    this.getInstallList()
                                }
                        })
                }).catch(() => {
                    // console.log('s')
                })
            },
            orderJiesuan (row) {
                this.$alert('确定将此单变更为已结算?', '安装单结算', {
                    confirmButtonText: '确定',
                }).then(() => {
                    this.$http.get(this.$reqUrl + `service.php?act=jiesuan&session_id=${localStorage.getItem('shouhou_session_id')}&install_id=${row.install_id}`)
                        .then(res => {
                        if (res.data.error === 0) {
                            this.$message.success(res.data.msg)
                            this.getInstallList()
                        }
                        if (res.data.error === 1) {
                            this.$message.error(res.data.msg)
                        }
                    })
                })
            },
            OrderBiangeng(row) {
                // console.log(new Date(row.yuyue_time));
                this.showBiangeng = true
                this.changeAddress = false
                this.bgform = row
                // this.selectname(row.install_id)
                this.biangengData.install_id = row.install_id
                this.biangengData.company_id = row.company_id
                this.biangengData.order_id = row.order_id
                this.biangengData.order_sn = row.order_sn
                this.biangengData.company_name = row.company_name
                this.biangengData.azTime = (new Date(row.yuyue_time))
                this.consl()
                this.biangengData.province = this.bgform.province
                this.biangengData.city = this.bgform.city
                this.biangengData.district = this.bgform.district
                this.biangengData.address = this.bgform.address
                this.biangengData.remark = this.bgform.remark
            },
            isChangeAddr() { //修改地址
                this.changeAddress = true
            },
            FalseChangeAddr() { //取消修改
                this.changeAddress = false
                this.biangengData.province = this.bgform.province
                this.biangengData.city = this.bgform.city
                this.biangengData.district = this.bgform.district
                this.biangengData.address = this.bgform.address
            },
            selectname(id) { //根据所选安装公司id判断安装公司
                this.selectCompany.forEach((item, i) => {
                    if (id === item.company_id) {
                        this.biangengData.company_name = item.company_name
                    }
                })
            },
            consl () { //日期转时间戳
                this.biangengData.yytime = Date.parse(this.biangengData.azTime.toLocaleDateString()).toString().slice(0, 10)
            },
            qrbiangeng () {
                if (this.changeAddress === false) {
                    this.biangengData.province = this.bgform.province
                    this.biangengData.city = this.bgform.city
                    this.biangengData.district = this.bgform.district
                    this.biangengData.address = this.bgform.address
                }
                var datas = {
                    address: this.biangengData.address,
                    mobile: this.bgform.mobile,
                    consignee: this.bgform.consignee,
                    yuyue_time: this.biangengData.yytime,
                    delivery_method: this.biangengData.goodsSelect,
                    company_id: this.biangengData.company_id,
                    company_name: this.biangengData.company_name,
                    remark: this.biangengData.remark,
                    install_id: this.biangengData.install_id,
                    order_id: this.biangengData.order_id,
                    // order_sn: this.biangengData.order_sn
                }
                // console.log(datas);
                this.$http.post(this.$reqUrl + `service.php?act=change_install_yuyue&session_id=${localStorage.getItem('shouhou_session_id')}`, qs.stringify(datas)).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success('变更成功')
                        this.showBiangeng = false
                        this.getInstallList()
                    } else {
                        this.$message.error('变更失败')
                    }
                })
            },
            //查看订单
            Look (row) {
                this.form = row
                this.InstallDetail = true
            },
            queren() {
                if (this.formData.company_name === '') {
                    this.$message.error('请选择下派公司')
                } else {
                    this.$message.success('chengg')
                    ChargeCompany(this.formData.install_id, this.formData.company_id, this.formData.company_name).then(res => {
                        if (res.data.error == 0) {
                            this.$message.success('下派成功')
                            this.dialogXiapai = false
                        }
                    }).then(error => {
                        this.$message.error(error.data.msg)
                    }).catch(err => {
                        console.log(err)
                    })
                }
            },
            tableRowClassName({row, rowIndex}) {
                if (rowIndex === 0 || rowIndex === 2 || rowIndex === 4 || rowIndex === 6 || rowIndex === 8) {
                    return 'warning-row';
                } else if (rowIndex === 1 || rowIndex === 3 || rowIndex === 5 || rowIndex === 7 || rowIndex === 9) {
                    return 'success-row';
                }
                return '';
            },
            async getCityList (id) {
                return getAddressSelect(id).then((res) => {
                    this.cityList = res.data;
                    return res.data;
                });
            },
            async getDistrictList (id) {
                return getAddressSelect(id).then(res => {
                    this.districtList = res.data;
                    return res.data;
                });
            },
        },
        watch: {
            'biangengData.province': async function (val, oldVal) {
                const data = await this.getCityList(val);
                if (data.length > 0) {
                    this.biangengData.city = data[0].region_id;
                }
            },
            'biangengData.city': async function (val, oldVal) {
                const data = await this.getDistrictList(val);
                if (data.length > 0) {
                    this.biangengData.district = data[0].region_id;
                }
            },
            async visible (val) {
                if (val) {
                    if (this.type === 1) {
                        this.getCityList(this.biangengData.province);
                        this.getDistrictList(this.biangengData.city);
                    } else {
                        const provinces = await this.getCityList(this.provinceList[0].region_id);
                        const districts = await this.getDistrictList(provinces[0].region_id);
                        this.biangengData.province = this.provinceList[0].region_id;
                        this.biangengData.city = provinces[0].region_id;
                        this.biangengData.district = districts[0].region_id;
                    }
                }
            },
            editData (val) {
                if (this.type === 3) {
                    const {province_checked_id, city_checked_id, district_checked_id, ...rest} = val;
                    this.biangengData = {
                        province: province_checked_id,
                        city: city_checked_id,
                        district: district_checked_id,
                        ...rest
                    };
                } else {
                    this.biangengData = {...val};
                }
            }
        },
        computed: {
            ...mapState(['provinceList']),
        }
    }
</script>
<style lang="less" >
    .el-table .cell{
        padding: 0px 0;
        font-size: 10px;
    }
    .wrapper{
        .bar {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
                button {
                    width: 100Px;
                    height: 37Px;
                    margin-right: 10Px;
                    font-size: 16px;
                    color: #ffffff;
                    background: #f56c31;
                    border-radius: 2px;
                }
        }
    }
    .el-table th>.cell{
        color:#ea6625;
    }
    .demo-table-expand {
        /*font-size: 0;*/
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }

</style>
<style lang="less">
    .el-table .warning-row {
        background: #d6f4fd;
    }

    .el-table .success-row {
        background: #d5ffde;
    }
    .el-table th>.cell{
        color:#ea6625;
    }
     .el-table td, .el-table th{
         padding: 0;
         height: 50px;
         line-height: 50px;
     }
</style>



// WEBPACK FOOTER //
// src/router/InstallationList.vue